export const llmProxyLocaldevVirtualKeysPath =
  '/ai-platform/llm-proxy-localdev/virtual-keys';

export const llmProxyAppsVirtualKeysPath =
  '/ai-platform/llm-proxy-apps/virtual-keys';
